import { PricebookExtended, PricebookState } from '../../../../data/Pricebook';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import Popper from '@mui/material/Popper';
import React, { MutableRefObject } from 'react';
import { pricebookFileUrl } from '../../priceebook.utils';
import { useReadPermission } from 'hooks/useUserRoles';
import { PermissionCode } from 'data/UserPermissions';
import { ReadOnlyWrapper } from 'components/common/ReadOnlyWrapper';

interface Props {
  pricebook: PricebookExtended;
  open: boolean;
  setOpen: (open: boolean) => void;
  popperAnchorRef: MutableRefObject<any>;
  doReplace: boolean;
  onPreview: (
    previewId: number,
    pricebookType?: string,
    companyName?: string,
    vendorName?: string
  ) => void;
  onReplaceClick: (pricebookId: number) => void;
}

const onDownloadPricebookClick = (pathToFile: string) => {
  window.open(pricebookFileUrl(pathToFile), '_blank');
};

const ActionsPopper = ({ pricebook, doReplace, open, setOpen, popperAnchorRef, onReplaceClick, onPreview }: Props) => {
  const handleClose = (event: any) => {
    if (
      popperAnchorRef.current &&
      (popperAnchorRef.current as any).contains(event.target)
    ) {
      return;
    }

    setOpen(false);
  };

  const showReplaceButton =
    pricebook.priceBookState === PricebookState.PUBLISHED &&
    !pricebook.replacementPricebookState;

  const { readOnly: readOnlyView } = useReadPermission(PermissionCode.VIEW_PRICEBOOKS);
  const { readOnly: readOnlyEdit } = useReadPermission(PermissionCode.NEW_PRICEBOOKS);

  return (
    <Popper
      open={open}
      anchorEl={popperAnchorRef.current}
      placement="bottom-end"
      transition
      disablePortal
      style={{ zIndex: 1 }}
    >
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{
            margin: 6,
          }}
        >
          <Paper>
            <ClickAwayListener onClickAway={handleClose}>
              <MenuList id="menu-list-grow">
                <ReadOnlyWrapper readOnly={readOnlyView}>
                <MenuItem
                  onClick={() => {
                    if (doReplace) {
                      onReplaceClick(pricebook.id);
                    } else {
                      onPreview(
                        pricebook.id,
                        pricebook.priceBookType,
                        pricebook.company?.companyName,
                        pricebook.vendor.name
                      );
                    }
                  }}
                  disabled={readOnlyView}
                >
                  Preview
                </MenuItem>
                </ReadOnlyWrapper>

                {pricebook.pathToFile && (
                  <ReadOnlyWrapper readOnly={readOnlyView}>
                    <MenuItem onClick={() => onDownloadPricebookClick(pricebook.pathToFile)}
                      disabled={readOnlyView}>
                      Download as .xlsx
                    </MenuItem>
                  </ReadOnlyWrapper>
                )}
                {showReplaceButton && (
                  <ReadOnlyWrapper readOnly={readOnlyEdit}>
                    <MenuItem onClick={() => onReplaceClick(pricebook.id)}
                      disabled={readOnlyEdit}>
                      Replace
                    </MenuItem>
                  </ReadOnlyWrapper>
                )}
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>);
};

export default ActionsPopper;